export const InsertText = 'insertText'

export const DeleteContentBackward = 'deleteContentBackward'

export const DeleteContentForward = 'deleteContentForward'

export const DeleteWordForward = 'deleteWordForward'

export const DeleteWordBackward = 'deleteWordBackward'

export const InsertLineBreak = 'insertLineBreak'

export const InsertCompositionText = 'insertCompositionText'

export const InsertFromPaste = 'insertFromPaste'
